if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Hledáme vaši zásilku...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Vyhledávání…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "CZ"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Příliš mnoho pokusů
            </div>

            <div class="ee-error-message">
                Provedli jste příliš mnoho vyhledávání po sobě. Počkejte minutu a zkuste to znovu.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Objednávka byla zrušena
            </div>

            <div class="ee-error-message">
                Tato objednávka byla zrušena a nebude zpracována.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Připravujeme vaši objednávku
                </div>

<div class="ee-info-message">


 <br>

    Vaše objednávka byla přijata a zpracovává se.

    <br><br>

    Sledovací číslo zatím nebylo přiděleno. Jakmile bude zásilka odeslána, sledovací informace budou k dispozici na této stránce a v e-mailu.

    <br><br>

    Máte-li další dotazy ohledně své objednávky, kontaktujte náš zákaznický servis.

    <br>

                    <a href="https://cz.euroelectronics.eu/pages/kontakt" class="ee-contact-link">
                        Kontaktujte nás
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Objednávka nebyla nalezena
                </div>

                <div class="ee-error-message">
                    Nepodařilo se nám najít žádnou objednávku odpovídající zadanému číslu objednávky a e-mailové adrese. Zkontrolujte, zda jsou údaje zadány správně, a zkuste to znovu.
                    <br><br>

                    Pokud potřebujete pomoc, kontaktujte náš zákaznický servis.
                    <br>

                    <a href="https://cz.euroelectronics.eu/pages/kontakt" class="ee-contact-link">
                        Přejít na kontaktní formulář
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Zásilka nalezena
                        </div>
<div class="ee-result-description">
                            Níže najdete informace o své zásilce. Kliknutím na tlačítko níže přejdete přímo ke sledování u dopravce.
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Číslo objednávky
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Sledovací číslo
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Sledovat zásilku
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Objednané produkty (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Došlo k chybě
                        </div>

                        <p>
                            Nepodařilo se připojit k systému sledování. Zkuste to prosím za chvíli znovu.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}
